import PropTypes from "prop-types";
import React from "react";

import { PlacementFactory } from "@swa-ui/placements";

import {
  AccessibilityAccommodationsFormFields,
  accessibilityAccommodationsFormFieldsPropTypes,
} from "./AccessibilityAccommodationsFormFields";
import {
  AnimalAssistanceFormField,
  animalAssistanceFormFieldsPropTypes,
} from "./AnimalAssistanceFormField";
import {
  OtherAssistanceFormFields,
  otherAssistanceFormFieldsPropTypes,
} from "./OtherAssistanceFormFields";
import styles from "./PassengerAccommodationsFormFields.module.scss";
import {
  PersonalWheelchairAssistanceFormFields,
  personalWheelchairAssistanceFormFieldsPropTypes,
} from "./PersonalWheelchairAssistanceFormFields";
import {
  WheelchairAssistanceFormField,
  wheelchairAssistanceFormFieldPropTypes,
} from "./WheelchairAssistanceFormField";

export const PassengerAccommodationsFormFields = (props) => {
  const {
    animalAssistanceFormFieldProps = {},
    accessibilityAccommodationsFormFieldsProps = {},
    otherAssistanceFormFieldsProps = {},
    personalWheelchairAssistanceFormFieldsProps = {},
    wheelchairAssistanceFormFieldProps = {},
  } = props;

  return (
    <div className={styles.container}>
      <PlacementFactory className={styles.disabilityOptionText} id="disabilityOptionText" />
      <div className={styles.formFieldsWrapper}>
        <AccessibilityAccommodationsFormFields {...accessibilityAccommodationsFormFieldsProps} />
        <AnimalAssistanceFormField {...animalAssistanceFormFieldProps} />
        <WheelchairAssistanceFormField {...wheelchairAssistanceFormFieldProps} />
        <PersonalWheelchairAssistanceFormFields {...personalWheelchairAssistanceFormFieldsProps} />
        <OtherAssistanceFormFields {...otherAssistanceFormFieldsProps} />
      </div>
    </div>
  );
};

PassengerAccommodationsFormFields.propTypes = {
  /** Props for accessibility accommodations component. */
  accessibilityAccommodationsFormFieldsProps: PropTypes.shape(
    accessibilityAccommodationsFormFieldsPropTypes
  ),

  /** Props for animal assistance component. */
  animalAssistanceFormFieldProps: PropTypes.shape(animalAssistanceFormFieldsPropTypes),

  /** Props for other assistance component. */
  otherAssistanceFormFieldsProps: PropTypes.shape(otherAssistanceFormFieldsPropTypes),

  /** Props for personal wheel chair assistance component. */
  personalWheelchairAssistanceFormFieldsProps: PropTypes.shape(
    personalWheelchairAssistanceFormFieldsPropTypes
  ),

  /** Props for wheel chair assistance component. */
  wheelchairAssistanceFormFieldProps: PropTypes.shape(wheelchairAssistanceFormFieldPropTypes),
};
